import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {
  DashboardKpiService,
  LastVsThisYearSalesAmountSummaryCardComponent,
  SalesSummaryEntity,
  Timespan
} from 'gung-dashboard';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';
import { startOfYear, subYears } from 'date-fns';

@Component({
    selector: 'otto-olsen-last-year-to-date-vs-this-year-to-date-sales-summary-card',
    templateUrl: './otto-olsen-last-year-to-date-vs-this-year-to-date-sales-summary-card.component.html',
    styleUrls: ['./otto-olsen-last-year-to-date-vs-this-year-to-date-sales-summary-card.component.scss'],
    standalone: false
})
export class OttoOlsenLastYearToDateVsThisYearToDateSalesSummaryCardComponent
  extends LastVsThisYearSalesAmountSummaryCardComponent
  implements OnInit
{
  salesAmountThisYear = 0;
  salesAmountLastYear = 0;
  loaded = false;

  @Input()
  preConditions: any;

  constructor(protected dashboardKpiService: DashboardKpiService) {
    super(dashboardKpiService);
  }

  ngOnInit(): void {
    const thisYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Year);
    const lastYearToDateSpan = {
      fromDate: startOfYear(subYears(new Date(), 1)),
      toDate: subYears(new Date(), 1)
    };

    forkJoin({
      salesSummaryGroupsThisYear: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisYearSpan.fromDate, null, this.preConditions)
        .pipe(first()),
      salesSummaryGroupsLastYear: this.dashboardKpiService
        .getSalesSummary(
          SalesSummaryEntity.PRODUCT,
          lastYearToDateSpan.fromDate,
          lastYearToDateSpan.toDate,
          this.preConditions
        )
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisYear, salesSummaryGroupsLastYear }) => {
      console.log({ salesSummaryGroupsThisYear, salesSummaryGroupsLastYear });
      this.salesAmountThisYear = salesSummaryGroupsThisYear.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.salesAmountLastYear = salesSummaryGroupsLastYear.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.loaded = true;
    });
  }
}
